export class Client {
  couleur_principale: string;
  couleur_secondaire: string;
  couleur3: string;
  couleur4: string;
  couleur5: string;
  font_family: string;
}
